import React from 'react';
import Box from '@material-ui/core/Box';
import makeStyles from '@material-ui/core/styles/makeStyles';
import CircularProgress from '@material-ui/core/CircularProgress';
import AppContext from "@jumbo/components/contextProvider/AppContextProvider/AppContext";
import { Alert } from '@material-ui/lab';
import { useContext } from 'react';

const useStyles = makeStyles(theme => ({
  root: {
    // position: 'absolute',
    position:'fixed',
    left: 0,
    top: 0,
    bottom:0,
    right:0,
    zIndex: 999999,
    // width: '100%',
    // height: '100%',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
    background:"rgba(0,0,0,0.05)"
  },
  alert:{
    backgroundColor:props => `${props.theme.ca.loader.bg} !important`,
    "& p":{
      color:props => props.theme.ca.loader.text,
    }
  },
  progress:{
    color:props => props.theme.ca.loader.text,
  }
}));

const PageLoader = ({message}) => {
  const {theme} = useContext(AppContext);
  const classes = useStyles({theme});

  return (
    <Box className={classes.root}>
      <Alert variant="filled" severity="info" icon={false} className={`shadow-xl ${classes.alert}`}>
        <div className="d-flex flex-row justify-content-center align-items-center px-2">
          <CircularProgress size="1.5rem" className={classes.progress} />
          <p className={`c-text-s2 m-0 ml-3`}>{message || "请稍候"}</p>
        </div>
      </Alert>
    </Box>
  );
};

export default PageLoader;
